// src/components/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import EvoWishesLogo from "../assets/evo_wishes.png";

const Header = () => {
  return (
    <header className="flex items-center justify-center px-4 py-4 bg-white shadow-sm">
      <Link to="/">
        <img
          src={EvoWishesLogo}
          alt="EvoWishes Logo"
          className="h-10 w-auto"
        />
      </Link>
    </header>
  );
};

export default Header;